// src/api/rateMarkup.ts
import { opsHttp } from "../auth/apiClient.ts";

/** Надбавка к курсу. Настраивается в админке, применяется при вводе курса заявки. */
export interface RateMarkupDto {
  /** Проценты, как в админке: 2 означает +2%. */
  percent: number;
  /** true — надбавка только для матчинга. */
  matchOnly: boolean;
  isEnabled: boolean;
}

export async function getRateMarkup(): Promise<RateMarkupDto> {
  const { data } = await opsHttp.get<RateMarkupDto>("/api/RateMarkup");
  return data ?? { percent: 0, matchOnly: true, isEnabled: false };
}
